// reducers/familyAppointmentReducer.js
import {
    FAMILY_CREATE_APPOINTMENT_REQUEST,
    FAMILY_CREATE_APPOINTMENT_SUCCESS,
    FAMILY_RESET_APPOINTMENT_STATE,
  } from '../actions/familyAppointmentTypes';
  
  const initialState = {
    familyAppointments: [], // Store appointments as an array
  };
  
  const familyAppointmentReducer = (state = initialState, action) => {
    switch (action.type) {
      case FAMILY_CREATE_APPOINTMENT_REQUEST:
        return {
          ...state,
        };
      case FAMILY_CREATE_APPOINTMENT_SUCCESS:
        return {
          ...state,
          familyAppointments: [...state.familyAppointments, action.payload], // Append payload
        };
      case FAMILY_RESET_APPOINTMENT_STATE:
        return initialState;
      default:
        return state;
    }
  };
  
  export default familyAppointmentReducer;